<template>
  <a-card :bordered="false" title="积分订单" :headStyle="{borderBottom:'0px',fontSize:'18px'}">
    <a-form>
      <search-header :col="3">
        <search-list>
          <a-form-item label="订单编号" v-bind="searchItemLayout">
            <a-input v-model="queryParams.orderNo" placeholder="请输入"></a-input>
          </a-form-item>
          <a-form-item label="订单状态" v-bind="searchItemLayout">
            <a-select style="width: 100%" v-model="queryParams.orderStatus" placeholder="请选择" allowClear>
              <a-select-option v-for="item in dataList" :key="item.key" :value="item.key">{{ item.value }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="商品信息" v-bind="searchItemLayout">
            <a-input v-model="queryParams.productSearchKey" placeholder="输入商品名称、商品ID"></a-input>
          </a-form-item>
        </search-list>
        <search-list>
          <a-form-item label="来源用户" v-bind="searchItemLayout">
            <a-input v-model="queryParams.memberSearchKey" placeholder="昵称/手机号"></a-input>
          </a-form-item>
          <a-form-item label="下单日期" v-bind="searchItemLayout">
            <a-range-picker @change="onDateChange" :value="selectedDate" style="width: 100%"/>
          </a-form-item>
          <a-form-item style="margin-left:5%;">
            <a-button type="primary" @click="onSearch">查询</a-button>
          </a-form-item>
        </search-list>
      </search-header>
    </a-form>
    <custom-page-table
      ref="table"
      :columns="getColumnsList()"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
      :enableSearch="false"
    >
      <template slot="amountSlots" slot-scope="rowItem">
        <span v-if="rowItem.record.orderPoints">{{ rowItem.record.orderPoints }}积分</span>
        <span v-if="rowItem.record.orderAmount">+{{ rowItem.record.orderAmount }}元</span>
      </template>
      <span slot="action" slot-scope="rowItem">
        <a @click="toOrderDetails(rowItem.record.orderId)">查看</a>
      </span>
    </custom-page-table>
  </a-card>
</template>

<script>
import searchFormMixins from '@/utils/mixins/searchFormMixins'

export default {
  name: 'IntegralOrderList',
  mixins: [searchFormMixins],
  components: {},
  data() {
    return {
      queryParams: {
        endDate: '',
        orderNo: '',
        orderStatus: undefined,
        memberSearchKey: '',
        productSearchKey: '',
        startDate: ''
      },
      dataList: [],
      loadPromise: params => this.getListPromise(params),
      selectedDate: undefined
    }
  },
  mounted() {
    this.getOrderStatusEnum()
  },
  methods: {
    getOrderStatusEnum() {
      this.getHttpServices().getIntegralApiService().post('admin/pointsOrder/getOrderStatusEnum').then(res => {
        this.getLogUtils().logWithTag('枚举', res)
        this.dataList = res && res.length > 0 ? res : []
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onSearch() {
      this.$refs.table.refresh(true)
    },
    //日期变更
    onDateChange(dates, dateStrArr) {
      this.selectedDate = dates
      this.queryParams.startDate = dateStrArr[0]//出游开始日期
      this.queryParams.endDate = dateStrArr[1]//出游结束日期
    },
    toOrderDetails(orderId) {
      const params = { orderId }
      this.openNewPage('IntegralOrderDetail', params)
    },
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getIntegralApiService().post('admin/pointsOrder/getBackPointsOrderPage', params)
    },
    getColumnsList() {
      return [
        {
          title: '订单编号',
          dataIndex: 'orderNo'
        },
        {
          title: '积分商品名称',
          dataIndex: 'productName'
        },
        {
          title: '订单金额',
          dataIndex: 'orderAmount',
          scopedSlots: { customRender: 'amountSlots' }
        },
        {
          title: '昵称',
          dataIndex: 'userName'
        },
        {
          title: '手机号',
          dataIndex: 'userPhone'
        },
        {
          title: '下单时间',
          dataIndex: 'createDate'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '100px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    }
  }
}
</script>
<style scoped>
.mb15 {
  margin-bottom: 15px;
}
</style>
